import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { noop } from 'lodash';

interface HighlightingContextType {
  highlighted: string;
  setHighlighted(newValue: string): void;
}

interface Props {
  children: ReactNode;
}

const HighlightingContext = createContext<HighlightingContextType>({
  highlighted: '',
  setHighlighted: noop,
});

export function HighlightingProvider({ children }: Props) {
  const [highlighted, setHighlighted] = useState('');
  const value = useMemo(
    () => ({
      highlighted,
      setHighlighted,
    }),
    [highlighted],
  );

  return <HighlightingContext.Provider value={value}>{children}</HighlightingContext.Provider>;
}

export function useHighlighting() {
  return useContext(HighlightingContext);
}
